const locale = {
  placeholder: 'Velg tid',
  rangePlaceholder: ['Starttid', 'Sluttid']
};
export default locale;